export function parseElevioArticleId(url: string): string | undefined {
  try {
    const articleId = url.match(/\/articles\/(\d+)/)?.at(1) ?? undefined;
    return articleId;
  } catch {
    return undefined;
  }
}
